const ACTION_SCOPE = "[User]";

export class SetUser {
  static readonly type = `${ACTION_SCOPE} Set User`;
  constructor(public accessToken: string) {}
}

export class ClearUser {
  static readonly type = `${ACTION_SCOPE} Clear User`;
  constructor(public clear = true) {}
}
